const mobile_fields = {
  time: {
    title: "Time",
    key: "time",
    className: "col-lg-4",
    type: "mobile_time",
    required: false,
  },
  price: {
    title: "Price",
    key: "price",
    className: "col-lg-4",
    type: "price_mobile",
    required: false,
  },
  remarks: {
    title: "Remarks",
    key: "remarks",
    className: "col-lg-12",
    type: "remarks",
    required: false,
  },
  cuisine: {
    title: "Cuisine",
    key: "cuisine",
    className: "col-lg-12",
    type: "cuisine",
    required: false,
  },
  venue: {
    title: "Venue",
    key: "venue",
    className: "col-lg-12",
    type: "venue",
    required: false,
  },
  price: {
    title: "Price",
    key: "price",
    className: "col-lg-12",
    type: "price",
    required: false,
  },
  display_duration: {
    title: "Duration",
    key: "duration",
    className: "col-lg-12",
    type: "display_duration",
    required: false,
  },
  duration: {
    title: "Duration",
    key: "availability_hours",
    className: "col-lg-12",
    type: "duration",
    required: false,
  },
  restrictions: {
    title: "restrictions",
    key: "restriction",
    className: "col-lg-12",
    type: "restrictions",
    required: false,
  },
  no_of_pat: {
    title: "No of Participants",
    key: "no_of_pat",
    className: "col-lg-12",
    type: "no_of_pat",
    required: false,
  },
  port: {
    title: "Port Code",
    key: "port_name",
    className: "col-lg-12",
    type: "port",
    required: false,
  },
  time: {
    title: "Time",
    key: "time",
    className: "col-lg-4",
    type: "time",
    required: false,
  },
  start_time: {
    title: "Start Time",
    key: "start_time",
    className: "col-lg-4",
    type: "time",
    required: false,
  },
  end_time: {
    title: "End Time",
    key: "end_time",
    className: "col-lg-4",
    type: "time",
    required: false,
  },
  upload_menu: {
    title: "Menu",
    key: "upload_menu",
    className: "col-lg-12",
    type: "menu",
    required: false,
  },
  cta_button_data: {
    title: "CTA",
    key: "cta_button_data",
    className: "col-lg-12",
    type: "cta_button_data",
    required: false,
  },
  fidelio_code: {
    title: "Fidelio Code",
    key: "fidelio_code",
    className: "col-lg-12",
    type: "fidelio_code",
    required: false,
  },
  deck_location: {
    title: "Deck Location",
    key: "deck_location",
    className: "col-lg-12",
    type: "deck",
    required: false,
  },
  activity_level: {
    title: "Activity Level",
    key: "activity_level",
    className: "col-lg-12",
    type: "activity_level",
    option: [
      {
        id: "Strenuous",
        name: "Strenuous",
      },
      { id: "Mild", name: "Mild" },
      { id: "Moderate", name: "Moderate" },
    ],
    required: false,
  },
  revenue_center: {
    title: "Revenue Center",
    key: "revenue_center",
    className: "col-lg-12",
    type: "revenue_center",
    required: false,
  },
  cta: {
    title: "Show CTA Button",
    key: "cta_button",
    className: "col-lg-12",
    type: "select",
    option: [
      {
        id: "yes",
        name: "Yes",
      },
      { id: "no", name: "No" },
    ],
    required: false,
  },
};
let fieldsName = [
  "fidelio_code",
  "deck_location",
  "venue",
  "time",
  "port",
  "display_duration",
  "port_code",
  "port_name",
  "no_of_pat",
  "cuisine",
  "description",
  "remarks",
  "restrictions",
  "upload_menu",
  "price",
  "duration",
  "availability_hours",
  "activity_level",
  "cta",
  "start_time",
  "end_time",
  "revenue_center",
  "cta_button",
  "cta_button_data",
];
export { mobile_fields, fieldsName };
